export default __webpack_public_path__ + "static/media/ToT.ebbeaeda.png";